import { useContext, useState } from "react";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import { Card, Tab, Tabs } from "react-bootstrap";
import ProducerMainTab from "@main/producers/pages/ProducerMainTab";
import { ListActionProvider as AddressListActionProvider } from "@bloonde/location/addresses/actions/list/ListActionContext";
import { RemoveActionProvider as AddressRemoveActionProvider } from "@bloonde/location/addresses/actions/remove/RemoveActionContext";
import { CreateActionProvider as AddressCreateActionProvider } from "@bloonde/location/addresses/actions/create/CreateActionContext";
import { EditActionProvider as AddressEditActionProvider } from "@bloonde/location/addresses/actions/edit/EditActionContext";
import AddressesPage from "@bloonde/location/addresses/pages/AddressesPage";
import { DetailsActionProvider as InvoiceAccountDetailsActionProvider } from "@bloonde/billing/invoice-accounts/actions/details/DetailsActionContext";
import InvoiceAccountMainTab from "@bloonde/billing/invoice-accounts/components/InvoiceAccountMainTab2";
import { DetailsActionProvider as PageDetailsActionProvider } from "@bloonde/cms/cms-pages/actions/details/DetailsActionContext";
import PageEditionPage from "@bloonde/cms/cms-pages/pages/PageEditionPage";
import { DetailsActionContext as ProducerDetailsActionContext } from "@main/producers/actions/details/DetailsActionContext";

function ProducerProfilePage(props: { formDefaultValues?: any }) {
  const { formDefaultValues } = props;
  const { user } = useContext(AuthContext);
  const { element } = useContext(ProducerDetailsActionContext);

  const producerId = user?.producer?.id ? String(user.producer.id) : "0";

  const addressesFilters = {
    addressable_id: producerId,
    addressable_type: "App\\Models\\Producer",
  };
  const invoiceAccountFormDefaultValues = {
    entity_id: producerId,
    entity_type: "App\\Models\\Producer",
  };

  const [mainDataTabLoaded, setMainDataTabLoaded] = useState(true);
  const [pageTabLoaded, setPageTabLoaded] = useState(false);

  const onSelect = (key: string) => {
    if (key === "main_data") {
      setMainDataTabLoaded(true);
    } else if (key === "page") {
      setPageTabLoaded(true);
    }
  };

  return (
    <Tabs
      defaultActiveKey="main_data"
      id="producer-profile-tabs"
      onSelect={(key: any) => onSelect(key)}
    >
      <Tab eventKey="main_data" title={t("main_data")}>
        {mainDataTabLoaded && (
          <ProducerMainTab
            producerId={producerId}
            formDefaultValues={formDefaultValues || { user: { role: "producer" } }}
          />
        )}
      </Tab>
      <Tab eventKey="page" title={t("more_info")} disabled={!element?.id}>
        {pageTabLoaded && (
          <div className="mb-5">
            <PageDetailsActionProvider>
              <PageEditionPage
                title={"page"}
                propPageId={(element as any)?.page?.id}
              />
            </PageDetailsActionProvider>
          </div>
        )}
      </Tab>
      <Tab eventKey="addresses" title={t("shipping_addresses")}>
        <Card className="mt-3">
          <Card.Body>
            <AddressListActionProvider>
              <AddressRemoveActionProvider>
                <AddressCreateActionProvider>
                  <AddressEditActionProvider>
                    <AddressesPage
                      filters={addressesFilters}
                      formDefaultValues={addressesFilters}
                      maxItems={1}
                    />
                  </AddressEditActionProvider>
                </AddressCreateActionProvider>
              </AddressRemoveActionProvider>
            </AddressListActionProvider>
          </Card.Body>
        </Card>
      </Tab>
      <Tab eventKey="invoice_account" title={t("invoice_account")}>
        <Card className="mt-3">
          <Card.Body>
            <InvoiceAccountDetailsActionProvider>
              <InvoiceAccountMainTab
                formDefaultValues={invoiceAccountFormDefaultValues}
              />
            </InvoiceAccountDetailsActionProvider>
          </Card.Body>
        </Card>
      </Tab>
    </Tabs>
  );
}

export default ProducerProfilePage;
